import { Link } from "react-router-dom";
import IntranetLayout from "@/components/IntranetLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Wrench, Bug, Sparkles, ClipboardList, ArrowRight } from "lucide-react";
import { PMSAssistantContent } from "./PMSAssistant";
import { DefectManagerContent } from "./DefectManager";
import AIManagerPanel from "@/components/ai/AIManagerPanel";

const MaintenanceHub = () => {
  return (
    <IntranetLayout>
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-[#00283C] font-display">Maintenance & PMS Hub</h1>
        <p className="text-sm text-muted-foreground">Unified workspace: PMS Assistant, Defect Manager and the Vel-iO PMS Manager — with human-in-the-loop approval.</p>
      </div>

      <Tabs defaultValue="ai" className="w-full">
        <TabsList className="bg-[#F4F7FA] mb-4">
          <TabsTrigger value="ai"><Sparkles className="w-4 h-4 mr-1" /> Vel-iO PMS Manager</TabsTrigger>
          <TabsTrigger value="assistant"><ClipboardList className="w-4 h-4 mr-1" /> PMS Assistant</TabsTrigger>
          <TabsTrigger value="defects"><Bug className="w-4 h-4 mr-1" /> Defect Manager</TabsTrigger>
          <TabsTrigger value="workbench"><Wrench className="w-4 h-4 mr-1" /> Full PMS Workbench</TabsTrigger>
        </TabsList>

        <TabsContent value="ai" className="mt-0">
          <AIManagerPanel
            hub="pms"
            title="Vel-iO PMS Manager"
            subtitle="I monitor overdue jobs, class-survey items, condition trends and draft work orders for your approval."
            accent="text-[#8CB43C]"
            context="Hub: Planned Maintenance System. Fleet: Velocity Vanguard, Velocity Cobalto, Velocity Paladio. Focus on overdue jobs, defects, class survey deadlines, condition monitoring."
          />
        </TabsContent>

        <TabsContent value="assistant" className="mt-0">
          <PMSAssistantContent />
        </TabsContent>

        <TabsContent value="defects" className="mt-0">
          <DefectManagerContent />
        </TabsContent>

        <TabsContent value="workbench" className="mt-0">
          <Card className="border-[#D0DDE6]">
            <CardContent className="p-8 text-center space-y-4">
              <Wrench className="w-12 h-12 mx-auto text-[#288CC8]" />
              <h3 className="text-xl font-bold text-[#00283C]">Full PMS Workbench</h3>
              <p className="text-sm text-muted-foreground max-w-xl mx-auto">
                The complete enterprise Planned Maintenance System — equipment register, jobs, work orders, deferrals, condition monitoring, spare parts and class surveys.
              </p>
              <Button asChild className="bg-[#288CC8] hover:bg-[#288CC8]/90">
                <Link to="/employee/maintenance">Open Workbench <ArrowRight className="w-4 h-4 ml-1" /></Link>
              </Button>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </IntranetLayout>
  );
};

export default MaintenanceHub;
